import { render, staticRenderFns } from "./DashboardRelatorios.vue?vue&type=template&id=5c9804e0&scoped=true"
import script from "./DashboardRelatorios.vue?vue&type=script&lang=js"
export * from "./DashboardRelatorios.vue?vue&type=script&lang=js"
import style0 from "./DashboardRelatorios.vue?vue&type=style&index=0&id=5c9804e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9804e0",
  null
  
)

export default component.exports